import { render, staticRenderFns } from "./platformProviceManagement.vue?vue&type=template&id=6acd66ae&scoped=true&"
import script from "./platformProviceManagement.vue?vue&type=script&lang=js&"
export * from "./platformProviceManagement.vue?vue&type=script&lang=js&"
import style0 from "./platformProviceManagement.vue?vue&type=style&index=0&id=6acd66ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acd66ae",
  null
  
)

export default component.exports